import BASE_URL from "../config";

// Places an order (Registered User or Guest). Backend computes prices
// server-side from real Product rows - the client only sends productId +
// quantity (+ optional selectedChoiceIds) per line item.
export const createOrder = async (payload, token) => {
  const response = await fetch(`${BASE_URL}/orders`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(payload),
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};

// Pushes a paid order to Shiprocket to create its shipment (Admin only).
export const createShipment = async (orderId, token) => {
  const response = await fetch(`${BASE_URL}/orders/${orderId}/shiprocket/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const result = await response.json().catch(() => ({}));

  return { ok: response.ok, status: response.status, ...result };
};

const authJson = async (path, method, token, body) => {
  const response = await fetch(`${BASE_URL}${path}`, {
    method,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: body ? JSON.stringify(body) : undefined,
  });
  const result = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, ...result };
};

// Customer self-service, allowed until the order is dispatched.
export const cancelOrder = (orderId, reason, token) =>
  authJson(`/orders/${orderId}/cancel`, "POST", token, { reason });

export const updateOrderAddress = (orderId, address, token) =>
  authJson(`/orders/${orderId}/address`, "PUT", token, address);

// Allowed until the parcel is delivered. `date` is YYYY-MM-DD.
export const rescheduleOrder = (orderId, { date, note }, token) =>
  authJson(`/orders/${orderId}/reschedule`, "POST", token, { date, note });
